import React from 'react';

export const ConfigurationContext = React.createContext();
